import React from 'react'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import '../../styles/pages.css'

const tabs = [
  { path: '/pim/products', label: 'Products' },
  { path: '/pim/brands', label: 'Brands' },
  { path: '/pim/categories', label: 'Categories' },
  { path: '/pim/dimensions', label: 'Dimensions' },
  { path: '/pim/review', label: 'Review' }
]

function PIMPage() {
  const location = useLocation()

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Product Information</h1>
        <p>Manage master products, brands, categories, and dimensions</p>
      </div>

      <div className="pageTabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname === tab.path || location.pathname.startsWith(tab.path + '/') ? 'active' : ''}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default PIMPage
